export type TournamentTrack = {
  id: string;
  name: string;
};

export const tournamentUsesTrack = (
  tracks: TournamentTrack[],
  trackId: string
) => {
  return !!tracks.find((t) => t.id === trackId);
};
